"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import { Desktop, Mobile } from "ui"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { extractProperty, getNonUmbracoUrl, Link } from "utils"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 32px;
  padding-bottom: 32px;
  border-top: 1px solid ${sharedColors.borderGray};
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0;
    border: none;
    gap: 24px;
    padding-bottom: 48px;
  }
`
const BoxesRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    justify-content: unset;
    gap: 24px;
  }
`
const Box = styled.div<{ href?: string; target?: string }>`
  display: flex;
  width: 152px;
  padding: 16px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 12px;
  border: 1px solid ${sharedColors.borderGray};
  text-decoration: none;
  ${({ theme }) => theme.breakpoints.up("md")} {
    min-width: 223px;
    width: fit-content;
  }
`
const StyledSubTitle = styled(Typography)<{ component?: React.ElementType }>`
  margin: 0px;
`

export default function Contact({ data }: { data: any }) {
  const contactUsTitle = extractProperty(data, "contactUsTitle")
  const contactInfoText = extractProperty(data, "contactInfoText")
  const boxItems = extractProperty(data, "boxItems") || []
  const boxes = boxItems.map((el: any) => ({
    icon: extractProperty(el, "icon"),
    linkName: extractProperty(el, "linktocontact")?.[0]?.name,
    linkUrl: getNonUmbracoUrl(extractProperty(el, "linktocontact")?.[0]?.url),
    type: extractProperty(el, "linktocontact")?.[0]?.type,
  })) as {
    icon: string
    linkName: string
    linkUrl: string
    type: string
  }[]
  return (
    <Container paddingMobile>
      <StyledContainer>
        <StyledSubTitle component="h2">{contactUsTitle}</StyledSubTitle>
        <BoxesRow>
          {boxes.map((el, i) => {
            return (
              <Box
                as={Link}
                href={el?.linkUrl}
                key={i}
                target={el?.type === "EXTERNAL" ? "_blank" : "_self"}
              >
                <Image
                  src={getUmbracoMediaUrl(el?.icon)}
                  alt="phone"
                  width={32}
                  height={32}
                />
                <Typography variant="body2">{el?.linkName}</Typography>
              </Box>
            )
          })}
          <Desktop>
            <Box>
              <Typography
                variant="body2"
                component="div"
                dangerouslySetInnerHTML={{ __html: contactInfoText }}
              />
            </Box>
          </Desktop>
        </BoxesRow>
        <Mobile>
          <Typography
            variant="body2"
            component="div"
            dangerouslySetInnerHTML={{ __html: contactInfoText }}
          />
        </Mobile>
      </StyledContainer>
    </Container>
  )
}
